import { spawn } from 'redux-saga/effects';

import { sagas as incidentSummarySagas } from './incidentSummaryModule';

export default function* systemStatusSagas() {
	yield spawn(incidentSummarySagas);
}
